import { css } from "@linaria/core";
import {
  combineTokens,
  units,
  breakpoints,
  makeBreakpoint,
  sliderTokens,
} from "@pm2/compat";

export const tokens = combineTokens("--slider-carousel", {
  itemsPerPage: 4,
});

export const wrapper = css`
  position: relative;
`;

export const slider = css`
  ${sliderTokens
    .__override({
      itemsPerPage: tokens.itemsPerPage(),
      itemMargin: units.px(30),
    })
    .toString()};

  overflow: hidden;

  & li {
    position: relative;

    display: flex;
    justify-content: center;
    align-items: center;
  }

  @media ${breakpoints.mobile.andDown().toQuery()} {
    ${sliderTokens.itemMargin.__override(units.px(15)).toString()};
  }

  @media ${makeBreakpoint(0, 1100).toQuery()} {
    &[data-desired-count="6"] {
      ${sliderTokens.itemsPerPage.__override(5).toString()};
    }
  }

  @media ${makeBreakpoint(0, 1030).toQuery()} {
    &[data-desired-count="6"],
    &[data-desired-count="5"] {
      ${sliderTokens.itemsPerPage.__override(4).toString()};
    }
  }

  @media ${makeBreakpoint(0, 800).toQuery()} {
    &[data-desired-count="6"],
    &[data-desired-count="5"],
    &[data-desired-count="4"] {
      ${sliderTokens.itemsPerPage.__override(3).toString()};
    }
  }

  @media ${makeBreakpoint(0, 525).toQuery()} {
    &[data-desired-count="6"],
    &[data-desired-count="5"],
    &[data-desired-count="4"],
    &[data-desired-count="3"] {
      ${sliderTokens.itemsPerPage.__override(2).toString()};
    }
  }
`;

export const navigationButton = css`
  position: absolute;
  top: 50%;
  z-index: 2;

  transform: translateY(-50%);

  &[data-direction="backwards"] {
    left: ${units.px(-25)};
  }

  &[data-direction="forwards"] {
    right: ${units.px(-25)};
  }
`;
